import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {TaarifPage} from './taarif.page';
import {GlobalModule} from "../../global-module/global-module.module";
import {InsuranceCalcComponent} from "../components/general/insurance-calc/insurance-calc.component";

const routes: Routes = [
    {
        path: '',
        component: TaarifPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        GlobalModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
    ],
    declarations: [TaarifPage],
    entryComponents: [InsuranceCalcComponent],
    exports: [InsuranceCalcComponent]
})
export class TaarifPageModule {
}
